import { getProspectId } from "@utils/storage";
import { OFFER_CONFIG } from "./constants";
import { keycloakUtils } from "./itsf/keycloak/keycloakUtils";

const PUBLIC_ENDPOINT = `${process.env.API_URL}${process.env.PUBLIC_ENDPOINT_PREFIX}`;
export const GET_VERIFICATION_CODE_ROUTE = `${PUBLIC_ENDPOINT}otp`;

export const getEircodeFinderRoute = (eircode: string) => `${PUBLIC_ENDPOINT}address?eircode=${eircode}`;
export const findAddress = (postalCode: string) =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/findAddress/${postalCode}`;
export const sendOtp = () => `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/sendOTP`;
export const validateMobileNumberPortRoute = (phoneNumber: string) => `${PUBLIC_ENDPOINT}port/operator/${phoneNumber}`;

export const validateVerificationCodeRoute = (otpUuid?: string) => `${PUBLIC_ENDPOINT}otp/${otpUuid}/validate`;

const API_V1 = "api/v1/";
const API_V2 = "api/v2/";
//const CATALOG_MS = "catalog/";
//const ACQUISITION_PROSPECTS_MS = "acquisition-prospects/";

const getSecuredEndpoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const getTwoWayAuthPublicAuthenticatedEndPoint = (prefixApiVersion?: string) =>
    `${process.env.MIDDLEWARE_API_URL}two_way_validation/${prefixApiVersion ?? ""}${
        process.env.PUBLIC_ENDPOINT_PREFIX
    }${process.env.SECURED_ENDPOINT_PREFIX}`;

export const getPublicEndpoint = (prefixMS?: string, prefixApiVersion?: string) =>
    `${process.env.API_URL}${prefixMS ?? ""}${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}`;

/*const baseUrlNoKeycloak = (prefixMS?: string, prefixApiVersion?: string) =>
    `${process.env.API_URL}${prefixMS ?? ""}${prefixApiVersion ?? ""}`;*/

const baseUrl = (prefixApiVersion?: string) =>
    keycloakUtils.isAuthenticated() ? getSecuredEndpoint(prefixApiVersion) : getPublicEndpoint(prefixApiVersion);

// Prospect V0
//export const CREATE_PROSPECT_ROUTE = `${getPublicEndpoint(ACQUISITION_PROSPECTS_MS,API_V1)}prospects`;
export const CREATE_PROSPECT_ROUTE = `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/create`;
export const CREATE_CROSS_SELL_ROUTE = `${process.env.MIDDLEWARE_API_URL}cross-sell/create`;
export const CHECK_ELIGIBILITY = `${process.env.MIDDLEWARE_API_URL}cross-sell/checkEligibility`;

export const linkProspectToUserRoute = (prospectId: string) =>
    `${getSecuredEndpoint()}prospect/${prospectId}/link_to_user`;

export const getCartRoute = () => `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${getProspectId()}/getCart`;
export const getCartCrossSellRoute = () => `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/getCart`;

export const customerDetailsRoute = () =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${getProspectId()}/getContact`;

export const customerDetailsCrossSellRoute = () =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/getContact`;
//export const customerDetailsRoute = () => `${baseUrl()}prospect/${getProspectId()}/customer_details`;

//export const updateTermsAndConditionRoute = () => `${baseUrl()}prospect/${getProspectId()}/terms_and_conditions`;
export const updateTermsAndConditionRoute = () =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${getProspectId()}/terms-and-conditions`;

export const updateTermsAndConditionCrossSellRoute = () =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/terms-and-conditions`;

// Prospect V1
export const addOfferRoute = (prospectId: string) =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${prospectId}/addOffer`;

export const addOfferCrossSellRoute = (prospectId: string) =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${prospectId}/addOffer`;

export const deleteOfferRoute = (cartOfferId: number) =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${getProspectId()}/deleteOffer/${cartOfferId}`;

export const deleteOfferCrossSellRoute = (cartOfferId: number) =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/deleteOffer/${cartOfferId}`;

export const portinRoute = (cartOfferId: number) =>
    `${baseUrl(API_V1)}prospect/${getProspectId()}/cart/offer/${cartOfferId}/port_in`;

//export const GET_OFFER_ROUTE = `${baseUrlNoKeycloak(CATALOG_MS, API_V1)}offers?brand=${OFFER_CONFIG.BRAND}&channel=${OFFER_CONFIG.CHANNEL}&acquisitionType=NEW_ACQUISITION`;
export const GET_OFFER_ROUTE = `${process.env.MIDDLEWARE_API_URL}catalog/offers`;

// mnp-facade V0
export const GET_PORT_IN_SLOT_ROUTE = `${getPublicEndpoint()}port/time/${OFFER_CONFIG.BRAND}/${OFFER_CONFIG.CHANNEL}`;

// elavon-facade V1
export const getIframeAndValidatePaymentRoute = () => `${baseUrl(API_V1)}hpp/prospects/${getProspectId()}`;

// validate number
export const VALIDATE_NUMBER_ROUTE = `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/validate/portInNumber`;

// add port in route
export const addPortinRoute = (cartOfferId: number) =>
    `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/${getProspectId()}/create/portInNumber/${cartOfferId}`;

export const addPortinCrossSellRoute = (cartOfferId: number) =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/create/portInNumber/${cartOfferId}`;

export const paymentRoute = (lang: string) =>
    `${process.env.MIDDLEWARE_API_URL}payments/${getProspectId()}/initialise?language=${lang}`;

export const FINALIZE_ORDER_ROUTE = `${
    process.env.MIDDLEWARE_API_URL
}acquisition-prospects/${getProspectId()}/finalise/order`;

export const checkIfEmailExists = () => `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/KC/checkEmailExists`;

// epic post paid modal data submit
export const EPIC_POST_PAID_MODAL_ROUTE = `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/portin/logRequest`;

export const paymentRouteCrossSell = (lang: string) =>
    `${process.env.MIDDLEWARE_API_URL}payments/cross-sell/${getProspectId()}/initialise?language=${lang}`;

export const GET_DEFAULT_CARD_ROUTE = `${process.env.MIDDLEWARE_API_URL}cross-sell/payments-service/api/v1/public/auth/payer/default_payment_method`;

export const CHECK_IF_ID_EXISTS_ROUTE = `${process.env.MIDDLEWARE_API_URL}acquisition-prospects/checkIdentityExists`;

export const finaliseRouteCrossSell = (anonymous: boolean) =>
    `${process.env.MIDDLEWARE_API_URL}cross-sell/${getProspectId()}/finalise/order?anonymous=${anonymous}`;

export const postTwoWayAuthResendOtpRoute = (lang: string) =>
    `${getTwoWayAuthPublicAuthenticatedEndPoint()}sendOtp?lang=${lang}`;

export const TWO_WAY_AUTH_VALIDATE_OTP_ROUTE = `${getTwoWayAuthPublicAuthenticatedEndPoint(API_V2)}verifyOtp`;

export const TWO_WAY_AUTH_CHECK_IF_VALIDATED_ROUTE = `${getTwoWayAuthPublicAuthenticatedEndPoint()}checkIfValidated`;
